import React, { useState } from 'react'
import { FloatButton, message } from 'antd';

//styles
import "./Layout.css"

//components
import Navbar from './navbar/Navbar';
import Sidebar from './sidebar/Sidebar';
import { FaWhatsapp } from 'react-icons/fa6';

interface Props {
    children: React.ReactNode
}

const Layout = ({children}:Props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState<boolean>(false);

  const redirect = () => {
    const numeroTelefono = '584221741571'; // Reemplaza con el número de teléfono
    let mensaje = '¡Hola! ¿Cómo puedo concretar la compra?';

    const urlWhatsApp = `https://wa.me/${numeroTelefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(urlWhatsApp, '_blank'); 

  }

  return (
    <div className='Layout-component'>

        <Navbar setOpen={setOpen}/>

        <Sidebar open={open} setOpen={setOpen} />
        <div className='Layout-children'>
          {children}
        </div>

        <FloatButton icon={<FaWhatsapp size={20} />}  onClick={() => redirect()} />;
    </div>
  )
}

export default Layout